export const VIEWER_FETCH_ERROR = 'VIEWER_FETCH_ERROR'
export const UPDATE_USER = 'UPDATE_USER'
export const UPDATE_USER_START = 'UPDATE_USER_START'
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS'
export const UPDATE_USER_ERROR = 'UPDATE_USER_ERROR'
export const UPDATE_USER_EMAIL = 'UPDATE_USER_EMAIL'
export const UPDATE_USER_EMAIL_START = 'UPDATE_USER_EMAIL_START'
export const UPDATE_USER_EMAIL_SUCCESS = 'UPDATE_USER_EMAIL_SUCCESS'
export const UPDATE_USER_EMAIL_ERROR = 'UPDATE_USER_EMAIL_ERROR'
export const UPDATE_USER_ORGANIZATION_ROLE = 'UPDATE_USER_ORGANIZATION_ROLE'
export const UPDATE_USER_ORGANIZATION_ROLE_START =
  'UPDATE_USER_ORGANIZATION_ROLE_START'
export const UPDATE_USER_ORGANIZATION_ROLE_SUCCESS =
  'UPDATE_USER_ORGANIZATION_ROLE_SUCCESS'
export const UPDATE_USER_ORGANIZATION_ROLE_ERROR =
  'UPDATE_USER_ORGANIZATION_ROLE_ERROR'
export const UPDATE_USER_PHOTO = 'UPDATE_USER_PHOTO'
export const UPDATE_USER_PHOTO_START = 'UPDATE_USER_PHOTO_START'
export const UPDATE_USER_PHOTO_SUCCESS = 'UPDATE_USER_PHOTO_SUCCESS'
export const UPDATE_USER_PHOTO_ERROR = 'UPDATE_USER_PHOTO_ERROR'

export const ARCHIVE_USER = 'ARCHIVE_USER'

export const SET_USER_AS_OWNER = 'SET_USER_AS_OWNER'
